import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableSet.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableCollectionJs.mjs';
import {
  MutableEntry12w2i19w0igk5 as MutableEntry,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  fill3hcjvebk42tyx as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function advance($this) {
  $l$loop: while ($this.q4q_1 < $this.s4q_1.x4q_1) {
    var idx = $this.s4q_1.w4q_1[$this.q4q_1];
    if (idx >= 0 && !($this.s4q_1.t4q_1[idx] == null))
      break $l$loop;
    $this.q4q_1 = $this.q4q_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$KeySet$iterator$1Class;
function CaseInsensitiveMap$KeySet$iterator$1() {
  if (CaseInsensitiveMap$KeySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.s4q_1 = this$0;
        this.q4q_1 = 0;
        this.r4q_1 = null;
        advance(this);
      }
      q1() {
        return this.q4q_1 < this.s4q_1.x4q_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().u6();
        var idx = this.s4q_1.w4q_1[this.q4q_1];
        this.r4q_1 = ensureNotNull(this.s4q_1.t4q_1[idx]);
        this.q4q_1 = this.q4q_1 + 1 | 0;
        advance(this);
        return ensureNotNull(this.r4q_1);
      }
      q6() {
        var tmp0_elvis_lhs = this.r4q_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.s4q_1.b4r(key);
        this.r4q_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$KeySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$KeySet$iterator$1Class;
}
function advance_0($this) {
  $l$loop: while ($this.c4r_1 < $this.e4r_1.x4q_1) {
    var idx = $this.e4r_1.w4q_1[$this.c4r_1];
    if (idx >= 0 && !($this.e4r_1.t4q_1[idx] == null))
      break $l$loop;
    $this.c4r_1 = $this.c4r_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$ValueCollection$iterator$1Class;
function CaseInsensitiveMap$ValueCollection$iterator$1() {
  if (CaseInsensitiveMap$ValueCollection$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.e4r_1 = this$0;
        this.c4r_1 = 0;
        this.d4r_1 = null;
        advance_0(this);
      }
      q1() {
        return this.c4r_1 < this.e4r_1.x4q_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().u6();
        var idx = this.e4r_1.w4q_1[this.c4r_1];
        this.d4r_1 = ensureNotNull(this.e4r_1.t4q_1[idx]);
        var tmp = this.e4r_1.u4q_1[idx];
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.c4r_1 = this.c4r_1 + 1 | 0;
        advance_0(this);
        return result;
      }
      q6() {
        var tmp0_elvis_lhs = this.d4r_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.e4r_1.b4r(key);
        this.d4r_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$ValueCollection$iterator$1Class = $;
  }
  return CaseInsensitiveMap$ValueCollection$iterator$1Class;
}
function advance_1($this) {
  $l$loop: while ($this.f4r_1 < $this.h4r_1.x4q_1) {
    var idx = $this.h4r_1.w4q_1[$this.f4r_1];
    if (idx >= 0 && !($this.h4r_1.t4q_1[idx] == null))
      break $l$loop;
    $this.f4r_1 = $this.f4r_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$EntrySet$iterator$1Class;
function CaseInsensitiveMap$EntrySet$iterator$1() {
  if (CaseInsensitiveMap$EntrySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.h4r_1 = this$0;
        this.f4r_1 = 0;
        this.g4r_1 = null;
        advance_1(this);
      }
      q1() {
        return this.f4r_1 < this.h4r_1.x4q_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().u6();
        var idx = this.h4r_1.w4q_1[this.f4r_1];
        this.g4r_1 = ensureNotNull(this.h4r_1.t4q_1[idx]);
        var tmp = ensureNotNull(this.g4r_1);
        var tmp_0 = this.h4r_1.u4q_1[idx];
        var entry = new (MapEntry())(this.h4r_1, tmp, !(tmp_0 == null) ? tmp_0 : THROW_CCE());
        this.f4r_1 = this.f4r_1 + 1 | 0;
        advance_1(this);
        return entry;
      }
      q6() {
        var tmp0_elvis_lhs = this.g4r_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.h4r_1.b4r(key);
        this.g4r_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$EntrySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$EntrySet$iterator$1Class;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function putWithoutTrackingOrderReturnIndex($this, key, value) {
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.t4q_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.t4q_1[index];
    if (existingKey == null) {
      $this.t4q_1[index] = key;
      $this.u4q_1[index] = value;
      $this.v4q_1 = $this.v4q_1 + 1 | 0;
      return index;
    }
    if (equals(existingKey, key, true)) {
      $this.u4q_1[index] = value;
      return index;
    }
    index = (index + 1 | 0) & ($this.t4q_1.length - 1 | 0);
  }
}
function findIndex($this, key) {
  if ($this.v4q_1 === 0)
    return -1;
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.t4q_1.length - 1 | 0);
  while (true) {
    var tmp0_elvis_lhs = $this.t4q_1[index];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return -1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var existingKey = tmp;
    if (equals(existingKey, key, true))
      return index;
    index = (index + 1 | 0) & ($this.t4q_1.length - 1 | 0);
  }
}
function ensureCapacity($this) {
  if (imul($this.v4q_1, 4) >= imul($this.t4q_1.length, 3)) {
    resize($this, imul($this.t4q_1.length, 2));
  }
}
function resize($this, newCapacity) {
  var oldKeys = $this.t4q_1;
  var oldValues = $this.u4q_1;
  var oldInsertionOrder = $this.w4q_1;
  var oldInsertionCount = $this.x4q_1;
  var tmp = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.t4q_1 = Array(newCapacity);
  var tmp_0 = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp_0.u4q_1 = Array(newCapacity);
  var tmp_1 = $this;
  var tmp_2 = 0;
  var tmp_3 = new Int32Array(newCapacity);
  while (tmp_2 < newCapacity) {
    tmp_3[tmp_2] = -1;
    tmp_2 = tmp_2 + 1 | 0;
  }
  tmp_1.w4q_1 = tmp_3;
  $this.v4q_1 = 0;
  $this.x4q_1 = 0;
  var inductionVariable = 0;
  if (inductionVariable < oldInsertionCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var oldIndex = oldInsertionOrder[i];
      if (oldIndex >= 0 && !(oldKeys[oldIndex] == null)) {
        var tmp_4 = ensureNotNull(oldKeys[oldIndex]);
        var tmp_5 = oldValues[oldIndex];
        $this.i4r(tmp_4, !(tmp_5 == null) ? tmp_5 : THROW_CCE());
      }
    }
     while (inductionVariable < oldInsertionCount);
}
function compactInsertionOrder($this) {
  if ($this.x4q_1 === 0)
    return Unit_instance;
  var writeIndex = 0;
  var inductionVariable = 0;
  var last = $this.x4q_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var idx = $this.w4q_1[i];
      if (idx >= 0 && !($this.t4q_1[idx] == null)) {
        var tmp = $this.w4q_1;
        var _unary__edvuaz = writeIndex;
        writeIndex = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = idx;
      }
    }
     while (inductionVariable < last);
  var inductionVariable_0 = writeIndex;
  var last_0 = $this.w4q_1.length;
  if (inductionVariable_0 < last_0)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      $this.w4q_1[i_0] = -1;
    }
     while (inductionVariable_0 < last_0);
  $this.x4q_1 = writeIndex;
}
var KeySetClass;
function KeySet() {
  if (KeySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor($outer) {
        return new.target.k4r($outer);
      }
      static k4r($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.j4r_1 = $outer;
        return this.c8($box);
      }
      q2() {
        return this.j4r_1.v4q_1;
      }
      l4r(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.keys does not support add');
      }
      j2(element) {
        return this.l4r((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      m4r(element) {
        return this.j4r_1.s2q(element);
      }
      t2(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.m4r((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$KeySet$iterator$1())(this.j4r_1);
      }
    }
    initMetadataForClass($, 'KeySet');
    KeySetClass = $;
  }
  return KeySetClass;
}
var ValueCollectionClass;
function ValueCollection() {
  if (ValueCollectionClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor($outer) {
        return new.target.o4r($outer);
      }
      static o4r($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.n4r_1 = $outer;
        return this.n6($box);
      }
      q2() {
        return this.n4r_1.v4q_1;
      }
      p4r(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.values does not support add');
      }
      j2(element) {
        return this.p4r(!(element == null) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$ValueCollection$iterator$1())(this.n4r_1);
      }
    }
    initMetadataForClass($, 'ValueCollection');
    ValueCollectionClass = $;
  }
  return ValueCollectionClass;
}
var EntrySetClass;
function EntrySet() {
  if (EntrySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor($outer) {
        return new.target.r4r($outer);
      }
      static r4r($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.q4r_1 = $outer;
        return this.c8($box);
      }
      q2() {
        return this.q4r_1.v4q_1;
      }
      s4r(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.entries does not support add');
      }
      j2(element) {
        return this.s4r((!(element == null) ? isInterface(element, MutableEntry()) : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$EntrySet$iterator$1())(this.q4r_1);
      }
    }
    initMetadataForClass($, 'EntrySet');
    EntrySetClass = $;
  }
  return EntrySetClass;
}
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor($outer, key, _value) {
        this.v4r_1 = $outer;
        this.t4r_1 = key;
        this.u4r_1 = _value;
      }
      m3() {
        return this.t4r_1;
      }
      n3() {
        return this.u4r_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals_0(this.t4r_1, other.m3());
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(this.n3(), other.n3());
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.t4r_1) ^ hashCode(this.n3());
      }
      toString() {
        return this.t4r_1 + '=' + toString_0(this.n3());
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [MutableEntry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.w4r_1 = 8;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.x4r_1 = [];
        var tmp_0 = this;
        // Inline function 'kotlin.emptyArray' call
        tmp_0.y4r_1 = [];
        this.z4r_1 = new Int32Array(0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.t4q_1 = Companion_getInstance().x4r_1;
        this.u4q_1 = Companion_getInstance().y4r_1;
        this.v4q_1 = 0;
        this.w4q_1 = Companion_getInstance().z4r_1;
        this.x4q_1 = 0;
        this.y4q_1 = null;
        this.z4q_1 = null;
        this.a4r_1 = null;
      }
      q2() {
        return this.v4q_1;
      }
      s2q(key) {
        return findIndex(this, key) >= 0;
      }
      t4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.s2q((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      t2q(key) {
        var index = findIndex(this, key);
        return index >= 0 ? this.u4q_1[index] : null;
      }
      v4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.t2q((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      n1() {
        return this.v4q_1 === 0;
      }
      y4() {
        if (this.v4q_1 > 0) {
          fill(this.t4q_1, null);
          fill(this.u4q_1, null);
          fill_0(this.w4q_1, -1);
          this.v4q_1 = 0;
          this.x4q_1 = 0;
        }
      }
      i4r(key, value) {
        if (this.t4q_1 === Companion_getInstance().x4r_1) {
          var tmp = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp.t4q_1 = Array(8);
          var tmp_0 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp_0.u4q_1 = Array(8);
          var tmp_1 = this;
          var tmp_2 = 0;
          var tmp_3 = new Int32Array(8);
          while (tmp_2 < 8) {
            tmp_3[tmp_2] = -1;
            tmp_2 = tmp_2 + 1 | 0;
          }
          tmp_1.w4q_1 = tmp_3;
        }
        var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
        var index = hash & (this.t4q_1.length - 1 | 0);
        while (true) {
          var existingKey = this.t4q_1[index];
          if (existingKey == null) {
            ensureCapacity(this);
            index = hash & (this.t4q_1.length - 1 | 0);
            while (!(this.t4q_1[index] == null)) {
              index = (index + 1 | 0) & (this.t4q_1.length - 1 | 0);
            }
            if (this.x4q_1 === this.w4q_1.length) {
              compactInsertionOrder(this);
            }
            this.t4q_1[index] = key;
            this.u4q_1[index] = value;
            var tmp_4 = this.w4q_1;
            var _unary__edvuaz = this.x4q_1;
            this.x4q_1 = _unary__edvuaz + 1 | 0;
            tmp_4[_unary__edvuaz] = index;
            this.v4q_1 = this.v4q_1 + 1 | 0;
            return null;
          }
          if (equals(existingKey, key, true)) {
            var oldValue = this.u4q_1[index];
            this.u4q_1[index] = value;
            return oldValue;
          }
          index = (index + 1 | 0) & (this.t4q_1.length - 1 | 0);
        }
      }
      b5(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.i4r(tmp, !(value == null) ? value : THROW_CCE());
      }
      a4s(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.n3();
          this.i4r(key, value);
        }
      }
      d5(from) {
        return this.a4s(from);
      }
      b4r(key) {
        var index = findIndex(this, key);
        if (index < 0)
          return null;
        var oldValue = this.u4q_1[index];
        var inductionVariable = 0;
        var last = this.x4q_1;
        if (inductionVariable < last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.w4q_1[i] === index) {
              this.w4q_1[i] = -1;
              break $l$loop;
            }
          }
           while (inductionVariable < last);
        this.t4q_1[index] = null;
        this.u4q_1[index] = null;
        this.v4q_1 = this.v4q_1 - 1 | 0;
        var nextIndex = (index + 1 | 0) & (this.t4q_1.length - 1 | 0);
        while (!(this.t4q_1[nextIndex] == null)) {
          var rehashKey = ensureNotNull(this.t4q_1[nextIndex]);
          var rehashValue = this.u4q_1[nextIndex];
          var oldRehashIndex = nextIndex;
          this.t4q_1[nextIndex] = null;
          this.u4q_1[nextIndex] = null;
          this.v4q_1 = this.v4q_1 - 1 | 0;
          var newIndex = putWithoutTrackingOrderReturnIndex(this, rehashKey, !(rehashValue == null) ? rehashValue : THROW_CCE());
          var inductionVariable_0 = 0;
          var last_0 = this.x4q_1;
          if (inductionVariable_0 < last_0)
            $l$loop_0: do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (this.w4q_1[i_0] === oldRehashIndex) {
                this.w4q_1[i_0] = newIndex;
                break $l$loop_0;
              }
            }
             while (inductionVariable_0 < last_0);
          nextIndex = (nextIndex + 1 | 0) & (this.t4q_1.length - 1 | 0);
        }
        return oldValue;
      }
      c5(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.b4r((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      w4() {
        var tmp0_elvis_lhs = this.y4q_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = KeySet().k4r(this);
          this.y4q_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l3() {
        var tmp0_elvis_lhs = this.z4q_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = EntrySet().r4r(this);
          this.z4q_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      x4() {
        var tmp0_elvis_lhs = this.a4r_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ValueCollection().o4r(this);
          this.a4r_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(other instanceof CaseInsensitiveMap()))
          return false;
        if (!(other.q2() === this.v4q_1))
          return false;
        var inductionVariable = 0;
        var last = this.t4q_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.t4q_1[i];
            if (!(k == null)) {
              var v = this.u4q_1[i];
              if (!equals_0(other.t2q(k), v))
                return false;
            }
          }
           while (inductionVariable <= last);
        return true;
      }
      hashCode() {
        var result = 0;
        var inductionVariable = 0;
        var last = this.t4q_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.t4q_1[i];
            if (!(k == null)) {
              var tmp = result;
              var tmp_0 = caseInsensitiveHashCode(Companion_getInstance(), k);
              // Inline function 'kotlin.hashCode' call
              var tmp0_safe_receiver = this.u4q_1[i];
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
              result = tmp + (tmp_0 ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) | 0;
            }
          }
           while (inductionVariable <= last);
        return result;
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
